import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener, Inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'smw-process-menu-item',
  templateUrl: 'menu-item.component.html',
  styleUrls: ['./menu-item.component.less'],
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProcessMenuItemComponent {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  /** Identifier of the step */
  step = input.required<unknown>();
  /** Emoji as icon */
  icon = input.required<string>();
  /** Name of the step */
  title = input.required<string>();

  goToAnchor() {
    const element = this.document.querySelector(`#${this.step()}`);
    if (!element) {
      return;
    }

    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  @HostListener('click')
  private onClick(): void {
    this.goToAnchor();
  }
}
